/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MfaMethod {
    Email = 1,
    Sms = 2,
    Otp = 3,
}
